import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px 0;
  max-width: 507px;
  width: 100%;
  margin: 0 auto;

  & button {
    padding: 0 44px;
  }
`;

export const Image = styled.img`
  max-width: 463px;
  width: 100%;
  margin-bottom: 45px;
`;

export const Title = styled.h2`
  margin: 0;
  font-size: 1.75rem;
`;

export const Text = styled.p`
  font-size: 1rem;
  margin-bottom: 24px;
  text-align: center;
`;
